<template>
	<form @submit.prevent="handleSubmit" class="phone-login-form">
		<div class="form-group" v-if="isdongm">
			<label class="form-label">区号(Country code)</label>
			<select v-model="countriesVal" class="country-select">
				<option value="" disabled>请选择区号</option>
				<option v-for="item in countries" :key="item.code" :value="item.code">
					{{ item.code }} {{ item.country }}
				</option>
			</select>
		</div>
		<div class="form-group" v-if="isdongm">
			<label class="form-label">手机号(phone)</label>
			<input v-model="phone" type="tel" class="form-input" placeholder="请输入手机号" maxlength="20"
				@input="validatePhone">
		</div>
		<div class="form-group" v-if="isdongm">
			<label class="form-label">验证码(Verification code)</label>
			<div class="input-with-button">
				<input v-model="code" type="text" class="form-input" placeholder="请输入验证码" maxlength="6">
				<button type="button" class="send-code-btn" :disabled="!canSendCode || countdown > 0" @click="sendCode">
					{{ countdown > 0 ? `${countdown}秒后重试` : '获取验证码' }}
				</button>
			</div>
		</div>

		<div class="form-group" v-if="!isdongm">
			<label class="form-label">账号(account number)</label>
			<input v-model="username" type="tel" class="form-input" placeholder="请输入手机号" maxlength="20">
		</div>
		<div class="form-group" v-if="!isdongm">
			<label class="form-label">密码(password)</label>
			<input v-model="password" type="password" class="form-input" placeholder="请输入手机号" maxlength="20">
		</div>

		<button type="submit" class="submit-btn">
			登录(log on)
		</button>
	</form>
</template>

<script>
	export default {
		name: 'PhoneLogin',

		data() {
			return {
				phone: '',
				code: '',
				countdown: 0,
				timer: null,
				password: "",
				username: "",
				isdongm: true, //是否是东盟
				pome: {},
				countriesVal: '',
				countries: [{
						"country": "中国",
						"country_en": "China",
						"code": "+86",
						"iso_code": "CN"
					},
					{
						"country": "美国",
						"country_en": "America",
						"code": "+1",
						"iso_code": "US"
					},
					{
						"country": "印度尼西亚",
						"country_en": "Indonesia",
						"code": "+62",
						"iso_code": "ID"
					},
					{
						"country": "泰国",
						"country_en": "Thailand",
						"code": "+66",
						"iso_code": "TH"
					},
					{
						"country": "新加坡",
						"country_en": "Singapore",
						"code": "+65",
						"iso_code": "SG"
					},
					{
						"country": "马来西亚",
						"country_en": "Malaysia",
						"code": "+60",
						"iso_code": "MY"
					},
					{
						"country": "越南",
						"country_en": "Vietnam",
						"code": "+84",
						"iso_code": "VN"
					},
					{
						"country": "菲律宾",
						"country_en": "Philippines",
						"code": "+63",
						"iso_code": "PH"
					},
					{
						"country": "缅甸",
						"country_en": "Myanmar",
						"code": "+95",
						"iso_code": "MM"
					},
					{
						"country": "柬埔寨",
						"country_en": "Cambodia",
						"code": "+855",
						"iso_code": "KH"
					},
					{
						"country": "老挝",
						"country_en": "Laos",
						"code": "+856",
						"iso_code": "LA"
					},
					{
						"country": "文莱",
						"country_en": "Brunei",
						"code": "+673",
						"iso_code": "BN"
					}
				]
			}
		},

		computed: {
			canSendCode() {
				// 必须选择区号
				if (!this.countriesVal) {
					return false;
				}

				// 提取纯数字进行验证
				const cleanPhone = this.phone.replace(/\D/g, '');

				// 根据区号验证不同的手机号格式
				if (this.countriesVal === '+86') {
					// 中国手机号：1开头，第二位是3-9，总共11位
					return /^1[3-9]\d{9}$/.test(cleanPhone);
				} else if (this.countriesVal === '+1') {
					// 美国手机号：10位数字，第一位是2-9，第四位是2-9
					return /^[2-9]\d{2}[2-9]\d{6}$/.test(cleanPhone);
				}

				// 其他区号的基本验证：6-15位数字
				return /^\d{6,15}$/.test(cleanPhone);
			},

			// canSubmit() {
			// 	return this.canSendCode && /^\d{6}$/.test(this.code);
			// }
		},

		methods: {
			validatePhone() {
				//this.phone = this.phone.replace(/\D/g, '')
			},

			sendCode() {
				if (!this.canSendCode) {
					if (!this.countriesVal) {
						this.$store.dispatch('showToast', '请选择区号')
					} else {
						this.$store.dispatch('showToast', '请输入正确的手机号')
					}
					return
				}

				// 发送时使用完整的手机号格式（区号+手机号）
				const fullPhone = this.phone.replace(/\D/g, '');

				this.HttpUtils.post('/api/wxmini/VISITOR/send', {
					phone: fullPhone,
					region: this.countriesVal
				}).then(res => {
					console.log(res)
					if (res.data.code === 200) {
						// 开始倒计时
						this.countdown = 60
						this.timer = setInterval(() => {
							this.countdown--
							if (this.countdown <= 0) {
								clearInterval(this.timer)
							}
						}, 1000)

						// 发送验证码
						this.$store.dispatch('showToast', '验证码已发送')
					} else {
						this.$message.error(res.data.msg)
					}
				})


			},

			handleSubmit() {
				// if (!this.canSubmit) return
				if (this.isdongm) {
					if (!this.countriesVal) {
						this.$store.dispatch('showToast', '请选择区号')
						return false;
					}
					if (!this.phone) {
						this.$store.dispatch('showToast', '请输入手机号')
						return false;
					}
					this.pome = {
						phone: this.phone,
						code: this.code,
						types: 1, //1表示东盟 ''表示其他项目
					}

				} else {
					this.pome = {
						// types: ,//1表示东盟 ''表示其他项目
						username: this.username,
						password: this.password,
					}
				}

				this.HttpUtils.post('/api/wxmini/loginWeb', this.pome).then(res => {
					console.log(res)
					if (res.data.code === 200) {
						sessionStorage.setItem('token', res.data.token)
						// sessionStorage.setItem('currentUser', res.data)
						sessionStorage.setItem('currentUser', JSON.stringify(res.data))
						// 2. 更新Vuex store（关键步骤）
						this.$store.commit('SET_USER', res.data)
						// 模拟登录
						this.$store.dispatch('showToast', '登录成功')

						this.$router.push({
							path: '/Home'
						})
					} else {
						this.$message.error(res.data.msg)
					}
				})
			}
		},

		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer)
			}
		}
	}
</script>

<style scoped>
	.phone-login-form {
		display: flex;
		flex-direction: column;
		gap: 24px;
		width: 100%;
		max-width: 100%;
		box-sizing: border-box;
	}

	.form-group {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.form-label {
		font-size: 14px;
		font-weight: 500;
		color: var(--text-dark);
	}

	.phone-input-wrapper {
		display: flex;
		gap: 12px;
		align-items: center;
	}

	.country-select {
		width: 100%;
		padding: 16px 20px;
		border: 1px solid var(--border-light);
		border-radius: var(--radius-md);
		font-size: 17px;
		background: rgba(255, 255, 255, 0.5);
		color: #333;
		cursor: pointer;
		transition: all 0.3s;
		appearance: none;
		background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
		background-repeat: no-repeat;
		background-position: right 16px center;
		background-size: 16px;
		padding-right: 48px;
		box-sizing: border-box;
	}

	.country-select:focus {
		outline: none;
		border-color: var(--primary);
		background: rgba(255, 255, 255, 0.8);
		box-shadow: 0 0 0 4px rgba(0, 122, 255, 0.1);
		color: #333;
	}

	.country-select option {
		padding: 8px 12px;
		background: white;
		color: #333;
	}

	.form-input {
		width: 100%;
		padding: 16px 20px;
		border: 1px solid var(--border-light);
		border-radius: var(--radius-md);
		font-size: 17px;
		background: rgba(255, 255, 255, 0.5);
		transition: all 0.3s;
		box-sizing: border-box;
	}

	.phone-input {
		flex: 1;
	}

	.form-input:focus {
		outline: none;
		border-color: var(--primary);
		background: rgba(255, 255, 255, 0.8);
		box-shadow: 0 0 0 4px rgba(0, 122, 255, 0.1);
	}

	.input-with-button {
		display: flex;
		gap: 12px;
		align-items: stretch;
	}

	.send-code-btn {
		flex-shrink: 0;
		padding: 16px 24px;
		background: var(--bg-glass);
		border: 1px solid var(--border-light);
		border-radius: var(--radius-md);
		font-size: 16px;
		font-weight: 500;
		color: var(--primary);
		cursor: pointer;
		transition: all 0.3s;
		white-space: nowrap;
		box-sizing: border-box;
	}

	.send-code-btn:hover:not(:disabled) {
		background: rgba(0, 122, 255, 0.05);
		border-color: var(--primary);
	}

	.send-code-btn:disabled {
		opacity: 0.6;
		cursor: not-allowed;
		color: var(--text-light);
	}

	.submit-btn {
		width: 100%;
		padding: 18px;
		background: linear-gradient(135deg, var(--primary), var(--secondary));
		color: white;
		border: none;
		border-radius: var(--radius-md);
		font-size: 18px;
		font-weight: 600;
		cursor: pointer;
		transition: all 0.3s;
		box-shadow: 0 8px 32px rgba(0, 122, 255, 0.3);
		box-sizing: border-box;
	}

	.submit-btn:hover:not(:disabled) {
		transform: translateY(-2px);
		box-shadow: 0 12px 40px rgba(0, 122, 255, 0.4);
	}

	.submit-btn:disabled {
		background: var(--text-light);
		cursor: not-allowed;
		box-shadow: none;
	}

	/* 大屏幕桌面端 (1200px以上) */
	@media (min-width: 1200px) {
		.phone-login-form {
			gap: 28px;
			max-width: 420px;
			margin: 0 auto;
		}

		.form-input,
		.country-select {
			padding: 18px 24px;
			font-size: 18px;
		}

		.country-select {
			padding-right: 52px;
		}

		.send-code-btn {
			padding: 18px 28px;
			font-size: 17px;
			min-width: 140px;
		}

		.submit-btn {
			padding: 20px;
			font-size: 19px;
		}
	}

	/* 标准桌面端 (1024px-1199px) */
	@media (min-width: 1024px) and (max-width: 1199px) {
		.phone-login-form {
			gap: 26px;
			max-width: 400px;
			margin: 0 auto;
		}

		.form-input,
		.country-select {
			padding: 17px 22px;
			font-size: 17px;
		}

		.send-code-btn {
			padding: 17px 26px;
			min-width: 130px;
		}

		.submit-btn {
			padding: 19px;
			font-size: 18px;
		}
	}

	/* 平板横屏 (768px-1023px) */
	@media (min-width: 768px) and (max-width: 1023px) {
		.phone-login-form {
			gap: 24px;
			max-width: 380px;
			margin: 0 auto;
		}

		.form-input,
		.country-select {
			padding: 16px 20px;
		}

		.send-code-btn {
			padding: 16px 24px;
			min-width: 120px;
		}
	}

	/* 平板竖屏/大手机 (640px-767px) */
	@media (min-width: 640px) and (max-width: 767px) {
		.phone-login-form {
			gap: 22px;
			max-width: 100%;
			padding: 0 20px;
			box-sizing: border-box;
		}

		.form-input,
		.country-select {
			padding: 15px 18px;
			font-size: 16px;
		}

		.send-code-btn {
			padding: 15px 20px;
			font-size: 15px;
			min-width: 110px;
		}

		.submit-btn {
			padding: 17px;
			font-size: 17px;
		}
	}

	/* 标准手机 (480px-639px) */
	@media (min-width: 480px) and (max-width: 639px) {
		.phone-login-form {
			gap: 20px;
			padding: 0 16px;
		}

		.form-input,
		.country-select {
			padding: 14px 16px;
			font-size: 16px;
		}

		.country-select {
			padding-right: 44px;
			background-size: 14px;
			background-position: right 14px center;
		}

		.input-with-button {
			gap: 10px;
		}

		.send-code-btn {
			padding: 14px 18px;
			font-size: 14px;
			min-width: 100px;
		}

		.submit-btn {
			padding: 16px;
			font-size: 16px;
		}
	}

	/* 小屏手机 (360px-479px) */
	@media (min-width: 360px) and (max-width: 479px) {
		.phone-login-form {
			gap: 18px;
			padding: 0 12px;
		}

		.form-group {
			gap: 6px;
		}

		.form-label {
			font-size: 13px;
		}

		.form-input,
		.country-select {
			padding: 13px 15px;
			font-size: 16px;
		}

		.country-select {
			padding-right: 42px;
			background-size: 13px;
			background-position: right 13px center;
		}

		.input-with-button {
			/* flex-direction: column;
			gap: 8px; */
		}

		.send-code-btn {
			/* width: 100%; */
			padding: 13px 15px;
			font-size: 14px;
			min-width: auto;
		}

		.submit-btn {
			padding: 15px;
			font-size: 15px;
		}
	}

	/* 超小屏手机 (320px-359px) */
	@media (max-width: 359px) {
		.phone-login-form {
			gap: 16px;
			padding: 0 8px;
		}

		.form-group {
			gap: 5px;
		}

		.form-label {
			font-size: 12px;
		}

		.form-input,
		.country-select {
			padding: 12px 14px;
			font-size: 15px;
		}

		.country-select {
			padding-right: 40px;
			background-size: 12px;
			background-position: right 12px center;
		}

		.input-with-button {
			flex-direction: column;
			gap: 6px;
		}

		.send-code-btn {
			width: 100%;
			padding: 12px 14px;
			font-size: 13px;
		}

		.submit-btn {
			padding: 14px;
			font-size: 14px;
		}
	}

	/* 横屏手机优化 */
	@media (max-height: 500px) and (orientation: landscape) {
		.phone-login-form {
			gap: 12px;
		}

		.form-group {
			gap: 4px;
		}

		.form-input,
		.country-select {
			padding: 10px 14px;
		}

		.send-code-btn {
			padding: 10px 16px;
		}

		.submit-btn {
			padding: 12px;
		}
	}

	/* 触摸设备优化 */
	@media (hover: none) and (pointer: coarse) {

		.form-input,
		.country-select,
		.send-code-btn,
		.submit-btn {
			min-height: 44px;
			/* iOS推荐的最小触摸目标 */
		}

		.send-code-btn:hover {
			background: var(--bg-glass);
			transform: none;
		}

		.submit-btn:hover {
			transform: none;
		}
	}

	/* 高密度屏幕 */
	@media (-webkit-min-device-pixel-ratio: 2),
	(min-resolution: 192dpi) {
		.country-select {
			background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
		}
	}

	/* 减少动画的设备 */
	@media (prefers-reduced-motion: reduce) {

		.form-input,
		.country-select,
		.send-code-btn,
		.submit-btn {
			transition: none;
		}

		.submit-btn:hover:not(:disabled) {
			transform: none;
		}
	}

	/* 高对比度模式 */
	@media (prefers-contrast: high) {

		.form-input,
		.country-select {
			border-width: 2px;
		}

		.form-input:focus,
		.country-select:focus {
			box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.3);
		}
	}
</style>